var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "shopInfoMain" }, [
    _c("div", { staticStyle: { display: "flex", "align-items": "center" } }, [
      _c("div", { staticStyle: { "flex-shrink": "0" } }, [
        _vm._v("店铺名称:  ")
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticStyle: {
            "white-space": "nowrap",
            overflow: "auto",
            "flex-grow": "1"
          }
        },
        [_vm._v(_vm._s(_vm.shopName))]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticStyle: { display: "flex", "align-items": "center" } }, [
      _c("span", { staticStyle: { "flex-shrink": "0" } }, [
        _vm._v("商家电话:  ")
      ]),
      _vm._v(" "),
      _c(
        "span",
        {
          staticStyle: {
            "flex-grow": "1",
            "white-space": "nowrap",
            overflow: "auto"
          }
        },
        [_vm._v(_vm._s(_vm.shopMobile))]
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          staticStyle: { "flex-shrink": "0" },
          attrs: { href: "tel:" + _vm.shopMobile }
        },
        [_c("button", [_vm._v("拨打")])]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "horizonGully" }),
    _vm._v(" "),
    _c("div", { staticStyle: { display: "flex", "align-items": "center" } }, [
      _c(
        "div",
        {
          staticStyle: {
            "white-space": "nowrap",
            overflow: "auto",
            "flex-grow": "1"
          }
        },
        [_vm._v(_vm._s(_vm.shopAddress))]
      ),
      _vm._v(" "),
      _c("div", {
        staticClass: "verticalGully",
        staticStyle: { "flex-shrink": "0" }
      }),
      _vm._v(" "),
      _c(
        "button",
        {
          staticStyle: { "flex-shrink": "0" },
          on: {
            click: function($event) {
              return _vm.urlLocate(
                "https://uri.amap.com/marker?position=" +
                  _vm.shopPositionLongitude +
                  "," +
                  _vm.shopPositionLatitude +
                  "&name=" +
                  _vm.shopAddress
              )
            }
          }
        },
        [_vm._v("导航")]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "horizonGully" }),
    _vm._v(" "),
    _c("div", {
      staticStyle: { width: "100%", height: "250px" },
      attrs: { id: "container" }
    }),
    _vm._v(" "),
    _c("div", { staticClass: "horizonGully" }),
    _vm._v(" "),
    _c(
      "div",
      { staticStyle: { "font-weight": "800", "text-align": "center" } },
      [_vm._v("\n        商家从业资质\n    ")]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticStyle: { "font-weight": "800", "text-align": "center" } },
      [_vm._v("\n        营业执照\n    ")]
    ),
    _vm._v(" "),
    _vm.shopCertificateImg && _vm.shopCertificateImg.length > 0
      ? _c(
          "div",
          {
            staticStyle: {
              position: "relative",
              width: "100%",
              height: "0",
              "padding-top": "calc(100% * 910 / 1404)"
            }
          },
          [
            _c("BaseImage", {
              staticStyle: {
                width: "100%",
                height: "100%",
                top: "0px",
                left: "0px",
                position: "absolute"
              },
              attrs: { url: _vm.getImgUrl(_vm.shopCertificateImg) }
            })
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "horizonGully" }),
    _vm._v(" "),
    _c("div", { staticStyle: { "font-weight": "800" } }, [
      _vm._v("\n        食品经营许可证\n    ")
    ]),
    _vm._v(" "),
    _vm.shopFoodCertificateImg && _vm.shopFoodCertificateImg.length > 0
      ? _c(
          "div",
          {
            staticStyle: {
              position: "relative",
              width: "100%",
              height: "0",
              "padding-top": "calc(100% * 910 / 1404)"
            }
          },
          [
            _c("BaseImage", {
              staticStyle: {
                width: "100%",
                height: "100%",
                top: "0px",
                left: "0px",
                position: "absolute"
              },
              attrs: { url: _vm.getImgUrl(_vm.shopFoodCertificateImg) }
            })
          ],
          1
        )
      : _c("div", { staticStyle: { "text-align": "center" } }, [_vm._v("无")])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }